"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AmbientLight_light;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbientLight = void 0;
const AbstractLight_1 = require("./AbstractLight");
class AmbientLight extends AbstractLight_1.AbstractLight {
    // #endregion Properties (1)
    // #region Constructors (1)
    /**
     * @ignore
     * @param light
     */
    constructor(light, viewer) {
        super(light, viewer);
        // #region Properties (1)
        _AmbientLight_light.set(this, void 0);
        __classPrivateFieldSet(this, _AmbientLight_light, light, "f");
    }
}
exports.AmbientLight = AmbientLight;
_AmbientLight_light = new WeakMap();
//# sourceMappingURL=AmbientLight.js.map